module.exports = __webpack_public_path__ + "static/media/20201219_110531_445_IMG_3311.2cb557a0.jpg";